import { message } from 'antd'

export const copyText = copyText => {
  navigator.clipboard.writeText(copyText)
  message.config({
    duration: 1,
    maxCount: 1,
  })
  message.success({
    content: 'Link Copied',
    className: 'custom-class',
    style: {
      marginTop: '50px',
      color: '#010E30',
      transitionDuration: '5s',
    },
  })
}
